export const QUIZ_DATA = {
  leo: {
    orbitId: 'leo',
    title: 'LEO Challenge',
    questions: [
      {
        id: 'leo_q1',
        question: 'What is the altitude range of Low Earth Orbit?',
        options: ['100–160 km', '160–2,000 km', '2,000–20,000 km', '35,786 km'],
        correctIndex: 1,
        explanation: 'LEO extends from 160 km (minimum to avoid too much drag) to 2,000 km altitude.',
        points: 20,
        difficulty: 'easy',
      },
      {
        id: 'leo_q2',
        question: 'Approximately how long does it take the ISS to orbit Earth once?',
        options: ['30 minutes', '90 minutes', '6 hours', '24 hours'],
        correctIndex: 1,
        explanation: 'The ISS orbits at ~400 km altitude with a period of approximately 92 minutes — about 16 orbits per day.',
        points: 20,
        difficulty: 'easy',
      },
      {
        id: 'leo_q3',
        question: 'What is the main reason LEO satellites have limited lifetimes?',
        options: ['Solar radiation', 'Atmospheric drag', 'Magnetic interference', 'Temperature extremes'],
        correctIndex: 1,
        explanation: 'Even at 400+ km, residual atmospheric drag slowly decelerates LEO satellites, causing them to spiral downward and re-enter.',
        points: 25,
        difficulty: 'medium',
      },
      {
        id: 'leo_q4',
        question: 'Which of these is NOT a typical use case for LEO satellites?',
        options: ['Earth observation', 'Human spaceflight', 'TV broadcasting', 'Internet constellations'],
        correctIndex: 2,
        explanation: 'TV broadcasting uses GEO satellites (e.g., DirecTV) because they appear stationary. LEO\'s fast movement makes it unsuitable for fixed satellite TV dishes.',
        points: 25,
        difficulty: 'medium',
      },
      {
        id: 'leo_q5',
        question: 'What orbital velocity must a LEO satellite maintain to stay in orbit?',
        options: ['~3 km/s', '~5.5 km/s', '~7.8 km/s', '~11.2 km/s'],
        correctIndex: 2,
        explanation: 'A LEO satellite must travel at approximately 7.8 km/s (28,000 km/h) for centrifugal force to balance gravity. 11.2 km/s is Earth\'s escape velocity.',
        points: 30,
        difficulty: 'hard',
      },
    ],
  },
  polar: {
    orbitId: 'polar',
    title: 'Polar Orbit Challenge',
    questions: [
      {
        id: 'polar_q1',
        question: 'What orbital inclination characterizes a true polar orbit?',
        options: ['0°', '45°', '90°', '180°'],
        correctIndex: 2,
        explanation: 'A polar orbit has an inclination of ~90°, meaning it passes directly over Earth\'s geographic poles.',
        points: 20,
        difficulty: 'easy',
      },
      {
        id: 'polar_q2',
        question: 'How does a polar satellite achieve complete Earth coverage?',
        options: ['It has cameras pointing sideways', 'Earth rotates beneath successive orbits', 'It moves very slowly', 'It uses multiple sensors'],
        correctIndex: 1,
        explanation: 'As Earth rotates eastward, each successive polar orbit\'s ground track shifts westward. Over ~14 orbits (one day), the satellite covers the entire surface.',
        points: 20,
        difficulty: 'easy',
      },
      {
        id: 'polar_q3',
        question: 'Which type of mission would most benefit from a polar orbit?',
        options: ['Broadcasting TV to Europe', 'Providing internet to equatorial regions', 'Mapping the entire Earth\'s surface', 'Monitoring a specific city continuously'],
        correctIndex: 2,
        explanation: 'Global Earth mapping requires coverage of all latitudes, including the poles. Polar orbits provide exactly this complete coverage.',
        points: 25,
        difficulty: 'medium',
      },
      {
        id: 'polar_q4',
        question: 'What is the main disadvantage of polar orbits compared to equatorial orbits?',
        options: ['Cannot image polar regions', 'Requires more launch energy', 'Shorter satellite lifetime', 'Worse resolution'],
        correctIndex: 1,
        explanation: 'Launching to a high-inclination polar orbit requires more fuel than equatorial launches because you cannot use Earth\'s equatorial rotational boost.',
        points: 25,
        difficulty: 'medium',
      },
      {
        id: 'polar_q5',
        question: 'A polar satellite passes over a specific city at 50°N latitude approximately how often?',
        options: ['Every 90 minutes', 'Once per day', 'Every 12 hours', 'Continuously'],
        correctIndex: 1,
        explanation: 'A polar satellite will pass over a mid-latitude city roughly once per day as the orbit progresses through all local times due to Earth\'s rotation.',
        points: 30,
        difficulty: 'hard',
      },
    ],
  },
  geo: {
    orbitId: 'geo',
    title: 'GEO Challenge',
    questions: [
      {
        id: 'geo_q1',
        question: 'At what altitude is the geostationary orbit?',
        options: ['2,000 km', '10,000 km', '20,200 km', '35,786 km'],
        correctIndex: 3,
        explanation: 'Geostationary orbit is exactly at 35,786 km above the equator — the unique altitude where orbital period equals 24 hours.',
        points: 20,
        difficulty: 'easy',
      },
      {
        id: 'geo_q2',
        question: 'Why does a GEO satellite appear stationary from Earth?',
        options: ['It isn\'t moving', 'Its orbital period matches Earth\'s rotation (24 hours)', 'It moves opposite to Earth\'s rotation', 'Gravity cancels out'],
        correctIndex: 1,
        explanation: 'At 35,786 km, a satellite\'s orbital period is exactly 24 hours — matching Earth\'s rotation speed. It therefore stays over the same point on Earth\'s surface.',
        points: 20,
        difficulty: 'easy',
      },
      {
        id: 'geo_q3',
        question: 'Who proposed using GEO for global communications in 1945?',
        options: ['Wernher von Braun', 'Arthur C. Clarke', 'Konstantin Tsiolkovsky', 'Hermann Oberth'],
        correctIndex: 1,
        explanation: 'Science fiction author and scientist Arthur C. Clarke proposed the geostationary orbit for telecommunications in 1945 — 12 years before Sputnik. It\'s now called the "Clarke Orbit."',
        points: 25,
        difficulty: 'medium',
      },
      {
        id: 'geo_q4',
        question: 'Why can\'t GEO satellites serve the polar regions (above 75°)?',
        options: ['Too much radiation there', 'The satellite\'s view angle is too shallow at high latitudes', 'Atmospheric interference', 'Communication frequencies are blocked'],
        correctIndex: 1,
        explanation: 'GEO satellites sit above the equator. At high latitudes, they appear very close to the horizon with a very shallow viewing angle, making signals weak and easily blocked by terrain.',
        points: 25,
        difficulty: 'medium',
      },
      {
        id: 'geo_q5',
        question: 'Approximately what is the one-way signal delay from GEO to Earth?',
        options: ['5 milliseconds', '25 milliseconds', '125 milliseconds', '500 milliseconds'],
        correctIndex: 2,
        explanation: 'At 35,786 km, light (and radio signals) takes about 119 ms to travel one-way. Round-trip delay is ~250 ms — noticeable in voice calls and problematic for gaming.',
        points: 30,
        difficulty: 'hard',
      },
    ],
  },
  meo: {
    orbitId: 'meo',
    title: 'MEO & Navigation Challenge',
    questions: [
      {
        id: 'meo_q1',
        question: 'What altitude do GPS satellites orbit at?',
        options: ['800 km', '2,000 km', '20,200 km', '35,786 km'],
        correctIndex: 2,
        explanation: 'GPS (Global Positioning System) satellites operate in MEO at 20,200 km altitude, with an orbital period of about 12 hours.',
        points: 20,
        difficulty: 'easy',
      },
      {
        id: 'meo_q2',
        question: 'How many GPS satellites are needed to calculate a 3D position?',
        options: ['1', '2', '3', '4'],
        correctIndex: 3,
        explanation: 'You need signals from at least 4 GPS satellites simultaneously: 3 to calculate x, y, z coordinates and a 4th to correct for receiver clock errors.',
        points: 20,
        difficulty: 'easy',
      },
      {
        id: 'meo_q3',
        question: 'What environmental challenge makes MEO satellites more expensive than LEO?',
        options: ['Extreme cold temperatures', 'Van Allen radiation belt exposure', 'Micrometeorite impacts', 'Solar wind pressure'],
        correctIndex: 1,
        explanation: 'MEO passes through Earth\'s Van Allen radiation belts — zones of high-energy charged particles. Satellites require expensive radiation-hardened electronics to survive here.',
        points: 25,
        difficulty: 'medium',
      },
      {
        id: 'meo_q4',
        question: 'Which country operates the GLONASS navigation system?',
        options: ['USA', 'China', 'Europe', 'Russia'],
        correctIndex: 3,
        explanation: 'Russia operates GLONASS (Global Navigation Satellite System), the Russian counterpart to the US GPS. It uses 24 satellites at 19,100 km altitude.',
        points: 25,
        difficulty: 'medium',
      },
      {
        id: 'meo_q5',
        question: 'GPS positioning uses which fundamental physics principle?',
        options: ['Doppler effect', 'Time-of-flight measurement (trilateration)', 'Triangulation using angles', 'Gravitational red shift'],
        correctIndex: 1,
        explanation: 'GPS uses trilateration: measuring the time it takes radio signals to travel from satellites to the receiver. Distance = speed of light × time. With 4 satellites\' distances, your 3D position is uniquely determined.',
        points: 30,
        difficulty: 'hard',
      },
    ],
  },
  sso: {
    orbitId: 'sso',
    title: 'SSO Challenge',
    questions: [
      {
        id: 'sso_q1',
        question: 'What does "sun-synchronous" mean for a satellite orbit?',
        options: ['The satellite orbits the Sun', 'The orbital plane maintains a constant angle to the Sun year-round', 'The satellite is solar-powered', 'It orbits in the direction of the Sun'],
        correctIndex: 1,
        explanation: 'A sun-synchronous orbit precesses (rotates) at exactly the same rate Earth orbits the Sun (1°/day), so the orbital plane maintains a constant solar illumination angle throughout the year.',
        points: 20,
        difficulty: 'easy',
      },
      {
        id: 'sso_q2',
        question: 'What approximate inclination do sun-synchronous orbits use?',
        options: ['0° (equatorial)', '53°', '90° (polar)', '97–99° (slightly retrograde)'],
        correctIndex: 3,
        explanation: 'SSO satellites have inclinations of 97-99° — slightly retrograde. Earth\'s equatorial bulge causes a retrograde orbital precession that, at this inclination, exactly matches the 0.9856°/day needed to stay sun-synchronous.',
        points: 20,
        difficulty: 'easy',
      },
      {
        id: 'sso_q3',
        question: 'Why is consistent solar illumination important for Landsat?',
        options: ['For solar power generation', 'To compare images taken months apart with same lighting', 'To avoid eclipse periods', 'For radio signal strength'],
        correctIndex: 1,
        explanation: 'Landsat crosses the equator at 10:00–10:30 AM local time on every orbit. This consistent sun angle means images from different dates can be meaningfully compared to track changes.',
        points: 25,
        difficulty: 'medium',
      },
      {
        id: 'sso_q4',
        question: 'What physical phenomenon allows SSO\'s precise orbital precession?',
        options: ['Solar radiation pressure', 'Earth\'s equatorial bulge (oblateness)', 'Atmospheric drag', 'Lunar gravity'],
        correctIndex: 1,
        explanation: 'Earth is not a perfect sphere — it\'s slightly flattened at the poles and bulges at the equator (oblateness). This mass asymmetry causes an orbital plane to precess. SSO uses this precession deliberately.',
        points: 25,
        difficulty: 'medium',
      },
      {
        id: 'sso_q5',
        question: 'How long has Landsat been continuously imaging Earth from SSO?',
        options: ['Since 1985', 'Since 1972', 'Since 1999', 'Since 2010'],
        correctIndex: 1,
        explanation: 'Landsat 1 launched in 1972, making it the longest continuous record of Earth\'s land surface from space (50+ years). Nine generations of Landsat satellites have maintained this dataset.',
        points: 30,
        difficulty: 'hard',
      },
    ],
  },
  heo: {
    orbitId: 'heo',
    title: 'HEO Challenge',
    questions: [
      {
        id: 'heo_q1',
        question: 'What defines a "highly elliptical orbit"?',
        options: ['Altitude above 1,000 km', 'Eccentricity close to 1 (very elongated ellipse)', 'Inclination greater than 45°', 'Period longer than 12 hours'],
        correctIndex: 1,
        explanation: 'HEO is defined by high eccentricity (0.5–0.9), creating a very elongated ellipse with a low perigee and extremely high apogee.',
        points: 20,
        difficulty: 'easy',
      },
      {
        id: 'heo_q2',
        question: 'Where does an HEO satellite spend most of its time?',
        options: ['Near perigee (closest point)', 'Near apogee (farthest point)', 'Halfway between perigee and apogee', 'Evenly throughout the orbit'],
        correctIndex: 1,
        explanation: 'Kepler\'s Second Law: satellites move slower at apogee. A highly elliptical satellite spends the majority of its orbital period near apogee, providing extended coverage of that region.',
        points: 20,
        difficulty: 'easy',
      },
      {
        id: 'heo_q3',
        question: 'Why do space telescopes like Chandra use HEO?',
        options: ['Lower operational costs', 'Escapes Earth\'s radiation belts for clean observations', 'Better resolution from higher altitude', 'Easier launch trajectory'],
        correctIndex: 1,
        explanation: 'HEO space telescopes spend observation time at high apogee, above Earth\'s radiation belts. They make observations for ~40 hours, then quickly pass through the belts near perigee before returning to observe again.',
        points: 25,
        difficulty: 'medium',
      },
      {
        id: 'heo_q4',
        question: 'According to Kepler\'s Second Law, how does a satellite\'s speed change throughout an HEO?',
        options: ['Constant speed throughout', 'Fastest near apogee, slowest near perigee', 'Fastest near perigee, slowest near apogee', 'Speed depends on mass only'],
        correctIndex: 2,
        explanation: 'Kepler\'s 2nd Law: a satellite sweeps equal areas in equal time. Near perigee (close to Earth, strong gravity), it moves fastest. Near apogee (far from Earth, weak gravity), it moves slowest.',
        points: 25,
        difficulty: 'medium',
      },
      {
        id: 'heo_q5',
        question: 'The Chandra X-ray Observatory has an apogee of ~134,000 km. How far is that relative to the Moon\'s distance?',
        options: ['About 1/10 the way', 'About 1/3 the way', 'About halfway', 'Beyond the Moon'],
        correctIndex: 1,
        explanation: 'The Moon is ~384,400 km from Earth. Chandra\'s apogee at 134,000 km is about 35% of the way to the Moon — remarkably far for an Earth-orbiting satellite!',
        points: 30,
        difficulty: 'hard',
      },
    ],
  },
  molniya: {
    orbitId: 'molniya',
    title: 'Molniya Challenge',
    questions: [
      {
        id: 'molniya_q1',
        question: 'What does "Molniya" mean in Russian?',
        options: ['Orbit', 'Satellite', 'Lightning', 'Northern'],
        correctIndex: 2,
        explanation: '"Molniya" (Молния) means "lightning" in Russian — named for the speed the satellite moves near perigee.',
        points: 20,
        difficulty: 'easy',
      },
      {
        id: 'molniya_q2',
        question: 'What is the orbital period of a Molniya orbit?',
        options: ['90 minutes', '6 hours', '12 hours', '24 hours'],
        correctIndex: 2,
        explanation: 'Molniya orbits have a 12-hour period — two complete orbits per day. This repeats the ground track twice daily, providing predictable coverage windows.',
        points: 20,
        difficulty: 'easy',
      },
      {
        id: 'molniya_q3',
        question: 'Why was the Molniya orbit specifically designed for Russia?',
        options: ['Russia wanted to compete with the US', 'Most Russian territory is too far north for GEO coverage', 'Russia lacked rockets to reach GEO', 'It was cheaper to operate'],
        correctIndex: 1,
        explanation: 'Most Russian territory lies above 50°N latitude. From these latitudes, GEO satellites (above the equator) barely rise above the horizon, giving very weak signals. Molniya hovers over northern Russia for 8 hours per orbit.',
        points: 25,
        difficulty: 'medium',
      },
      {
        id: 'molniya_q4',
        question: 'What is the "critical inclination" used by Molniya and Tundra orbits?',
        options: ['45°', '51.6°', '63.4°', '90°'],
        correctIndex: 2,
        explanation: 'At exactly 63.4° inclination, Earth\'s oblateness causes zero apsidal precession. The orbit\'s apogee stays fixed over the same latitude permanently — crucial for consistent polar coverage.',
        points: 25,
        difficulty: 'medium',
      },
      {
        id: 'molniya_q5',
        question: 'How many Molniya satellites are needed for continuous 24-hour northern hemisphere coverage?',
        options: ['1', '2', '3', '6'],
        correctIndex: 2,
        explanation: 'Three Molniya satellites spaced 120° apart in orbital phase provide continuous coverage. As one descends from apogee, the next is rising to its apogee position — like a relay race.',
        points: 30,
        difficulty: 'hard',
      },
    ],
  },
  tundra: {
    orbitId: 'tundra',
    title: 'Tundra Orbit Challenge',
    questions: [
      {
        id: 'tundra_q1',
        question: 'What is the main difference between Tundra and Molniya orbits?',
        options: ['Different inclinations', '12-hour vs 24-hour orbital period', 'Different eccentricities only', 'Different altitudes only'],
        correctIndex: 1,
        explanation: 'Both use 63.4° inclination. The key difference: Molniya has a 12-hour period (2 orbits/day), while Tundra has a 24-hour period (1 orbit/day) — making it geosynchronous.',
        points: 20,
        difficulty: 'easy',
      },
      {
        id: 'tundra_q2',
        question: 'What does "geosynchronous" mean?',
        options: ['Stationary over one point', '24-hour orbital period matching Earth\'s rotation', 'Synchronized with GPS', 'Polar orbit'],
        correctIndex: 1,
        explanation: 'Geosynchronous means the orbital period equals Earth\'s rotation (24 hours). Geostationary is a special case of geosynchronous with 0° inclination. Tundra is geosynchronous but inclined.',
        points: 20,
        difficulty: 'easy',
      },
      {
        id: 'tundra_q3',
        question: 'Japan\'s QZSS uses a modified Tundra orbit. What problem does it solve?',
        options: ['Nuclear detection', 'GPS signal blockage in mountainous urban areas', 'Polar communications', 'Television broadcasting'],
        correctIndex: 1,
        explanation: 'Japan\'s mountainous terrain and dense cities cause GPS signals to be blocked. QZSS (Quasi-Zenith) satellites appear nearly overhead (near zenith) for extended periods, providing GPS augmentation from high elevation angles.',
        points: 25,
        difficulty: 'medium',
      },
      {
        id: 'tundra_q4',
        question: 'Compared to Molniya, the Tundra orbit has a lower eccentricity (~0.27 vs ~0.74). What does this mean practically?',
        options: ['More fuel efficient', 'Less extreme speed variation, simpler operations', 'Better polar coverage', 'Shorter period'],
        correctIndex: 1,
        explanation: 'Lower eccentricity means less difference between perigee and apogee speeds. This simplifies satellite operations, reduces radiation belt stress, but provides shorter "dwell time" over the target region per orbit.',
        points: 25,
        difficulty: 'medium',
      },
      {
        id: 'tundra_q5',
        question: 'What does a satellite\'s ground track look like for a Tundra orbit?',
        options: ['Perfect circle over North Pole', 'A figure-8 centered on a high-latitude region', 'Straight equatorial line', 'Random pattern'],
        correctIndex: 1,
        explanation: 'A Tundra (geosynchronous) orbit with inclination traces a figure-8 (analemma) pattern on the ground. The loops are asymmetric — the northern loop is larger due to the apogee dwell time.',
        points: 30,
        difficulty: 'hard',
      },
    ],
  },
  graveyard: {
    orbitId: 'graveyard',
    title: 'Graveyard Orbit Challenge',
    questions: [
      {
        id: 'grave_q1',
        question: 'What is the graveyard orbit\'s altitude relative to GEO?',
        options: ['500 km below GEO', 'Same altitude as GEO', 'About 300 km above GEO', '10,000 km above GEO'],
        correctIndex: 2,
        explanation: 'The graveyard orbit is approximately 300 km above the geostationary orbit (35,786 km), placing dead satellites out of the way of active GEO traffic.',
        points: 20,
        difficulty: 'easy',
      },
      {
        id: 'grave_q2',
        question: 'How long will satellites in the graveyard orbit remain there?',
        options: ['A few decades', 'Hundreds of years', 'Thousands of years', 'Billions of years'],
        correctIndex: 3,
        explanation: 'At 36,000+ km altitude, there is essentially no atmospheric drag. Without drag to slow them down, graveyard satellites will orbit indefinitely — for billions of years.',
        points: 20,
        difficulty: 'easy',
      },
      {
        id: 'grave_q3',
        question: 'Why do regulatory agencies require satellite operators to plan for graveyard disposal before launch?',
        options: ['Safety during launch', 'To clear valuable GEO orbital slots for future use', 'Environmental regulations', 'To test spacecraft systems'],
        correctIndex: 1,
        explanation: 'GEO orbital slots are internationally managed limited resources. Requiring disposal plans ensures operational satellites don\'t collide with dead ones, and that slots become available for future missions.',
        points: 25,
        difficulty: 'medium',
      },
      {
        id: 'grave_q4',
        question: 'Approximately how much delta-V does it take to boost a GEO satellite to graveyard orbit?',
        options: ['~1 m/s', '~10 m/s', '~100 m/s', '~1,000 m/s'],
        correctIndex: 1,
        explanation: 'Boosting from GEO to graveyard orbit (~300 km higher) requires only about 10-11 m/s of delta-V — a very small amount that operators deliberately save as the last fuel expenditure.',
        points: 25,
        difficulty: 'medium',
      },
      {
        id: 'grave_q5',
        question: 'What happened to some GEO satellites that weren\'t properly retired?',
        options: ['They fell to Earth harmlessly', 'They exploded from pressurized fuel tanks, creating debris fields', 'They moved into stable frozen orbits', 'They eventually reached L2 naturally'],
        correctIndex: 1,
        explanation: 'Some retired GEO satellites with residual propellant exploded in orbit, creating dangerous debris clouds. This is why modern regulations require "passivation" — venting remaining fuel and pressurized gases before retirement.',
        points: 30,
        difficulty: 'hard',
      },
    ],
  },
  hohmann: {
    orbitId: 'hohmann',
    title: 'Hohmann Transfer Challenge',
    questions: [
      {
        id: 'hohmann_q1',
        question: 'How many engine burns does a Hohmann transfer require?',
        options: ['1', '2', '3', '4'],
        correctIndex: 1,
        explanation: 'A Hohmann transfer uses exactly 2 burns: Burn 1 enters the transfer ellipse, Burn 2 circularizes at the target orbit. It\'s the most fuel-efficient 2-burn transfer between circular orbits.',
        points: 20,
        difficulty: 'easy',
      },
      {
        id: 'hohmann_q2',
        question: 'In which direction must the first burn of a Hohmann transfer be to raise an orbit?',
        options: ['Against the direction of travel (retrograde)', 'In the direction of travel (prograde)', 'Perpendicular to orbit', 'Toward Earth (radial)'],
        correctIndex: 1,
        explanation: 'To raise an orbit, you must increase velocity (prograde burn). This adds energy, raising the opposite side of the orbit to the target altitude. Retrograde burns lower orbits.',
        points: 20,
        difficulty: 'easy',
      },
      {
        id: 'hohmann_q3',
        question: 'Who calculated the Hohmann transfer mathematically?',
        options: ['Isaac Newton', 'Walter Hohmann', 'Yuri Gagarin', 'Hermann Oberth'],
        correctIndex: 1,
        explanation: 'Walter Hohmann, a German engineer, calculated this optimal orbital transfer maneuver and published it in 1925 — over 30 years before the Space Age began.',
        points: 25,
        difficulty: 'medium',
      },
      {
        id: 'hohmann_q4',
        question: 'How long does a Hohmann transfer from Earth to Mars take?',
        options: ['~1 month', '~3 months', '~8.5 months', '~2 years'],
        correctIndex: 2,
        explanation: 'A Hohmann transfer from Earth\'s orbit to Mars\' orbit takes approximately 8.5 months (259 days) — half the period of the transfer ellipse. Launch windows occur every ~26 months.',
        points: 25,
        difficulty: 'medium',
      },
      {
        id: 'hohmann_q5',
        question: 'For which case is a bi-elliptic transfer more fuel-efficient than a Hohmann transfer?',
        options: ['When target orbit is less than 2x the initial orbit', 'When target orbit is more than ~11.9x the initial orbit', 'When inclination changes are required', 'When the spacecraft is very massive'],
        correctIndex: 1,
        explanation: 'Counterintuitively, for very large orbit ratio changes (>11.94×), a 3-burn bi-elliptic transfer uses less fuel than the 2-burn Hohmann. The extra detour via a very high intermediate orbit actually saves propellant.',
        points: 30,
        difficulty: 'hard',
      },
    ],
  },
  lagrange: {
    orbitId: 'lagrange',
    title: 'Lagrange Points Challenge',
    questions: [
      {
        id: 'lag_q1',
        question: 'How many Lagrange points exist in a two-body gravitational system?',
        options: ['2', '3', '4', '5'],
        correctIndex: 3,
        explanation: 'There are exactly 5 Lagrange points (L1–L5) in any two-body system. L1, L2, L3 are collinear (on the line connecting the two bodies). L4 and L5 form equilateral triangles.',
        points: 20,
        difficulty: 'easy',
      },
      {
        id: 'lag_q2',
        question: 'At which Lagrange point does the James Webb Space Telescope orbit?',
        options: ['L1', 'L2', 'L3', 'L4'],
        correctIndex: 1,
        explanation: 'JWST orbits the Sun-Earth L2 point, about 1.5 million km "behind" Earth (away from the Sun). Here it can keep Earth, Sun, and Moon behind its sunshield while observing the cold, dark universe.',
        points: 20,
        difficulty: 'easy',
      },
      {
        id: 'lag_q3',
        question: 'Which Lagrange points are inherently stable (require no station-keeping)?',
        options: ['L1 and L2', 'L2 and L3', 'L3 and L4', 'L4 and L5'],
        correctIndex: 3,
        explanation: 'L4 and L5 are stable equilibrium points — like valleys, where objects naturally stay. L1, L2, and L3 are unstable saddle points — like hilltops, requiring active station-keeping burns.',
        points: 25,
        difficulty: 'medium',
      },
      {
        id: 'lag_q4',
        question: 'What are the asteroids at Jupiter\'s L4 and L5 points called?',
        options: ['Centaurs', 'Trans-Neptunian Objects', 'Trojans', 'Near-Earth Asteroids'],
        correctIndex: 2,
        explanation: 'The asteroids naturally accumulated at Jupiter\'s L4 and L5 points are called Trojans. There are over 1 million Trojans at Jupiter\'s L4 (Greeks) and L5 (Trojans proper), present since the early solar system.',
        points: 25,
        difficulty: 'medium',
      },
      {
        id: 'lag_q5',
        question: 'How does a "halo orbit" at L2 differ from being exactly at L2?',
        options: ['Halo orbits are at a different altitude', 'Halo orbits circle around L2, avoiding being in Earth\'s shadow', 'Halo orbits are faster', 'There is no difference'],
        correctIndex: 1,
        explanation: 'L2 is exactly in Earth\'s shadow from the Sun. A halo orbit makes a small loop around L2, keeping the spacecraft in sunlight for power while still enjoying the L2 thermal/observational environment. JWST uses a specific Lyapunov/halo orbit around L2.',
        points: 30,
        difficulty: 'hard',
      },
    ],
  },
};
